import { useState } from 'react';
import Metadata from '../components/Metadata';
import { metadata } from '../data';

export default function Family() {
  const [activeSlide, setActiveSlide] = useState(0);

  const slides = [
    {
      name: "Davide Piccolo",
      role: "Bar Manager and sommelier",
      credentials: "DIPWSET",
      quote: "Davide, holder of the WSET Level 4 Diploma, has curated our wine list. With more than 15 years of experience, he combines deep knowledge with genuine curiosity, guiding guests to wines that suit both the person and the occassion.",
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/david-bf3i7458-web.jpg"
    },
    {
      name: "Andreas Hierwagen",
      role: "Founder & Host",
      credentials: "",
      quote: "Having grown up at La Fontaine, Andreas has worked just about every job the house has to offer before taking over from his father. With La Fable, he wants to extend the same spirit of generosity he grew up with - adding exceptional wines to the story.",
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/andreas-bf3i7463-web.jpg"
    },
    {
      name: "William Bretlau",
      role: "Bar Manager at La Fontaine & leading the cocktail programme at La Fable",
      credentials: "",
      quote: "After six years at La Fontaine, the last two as Bar Manager, William has become a familiar face behind the bar. His easy charm and instinct for people make him the perfect person to lead the cocktail programme at La Fable.",
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/william-bf3i7133-web.jpg"
    },
    {
      name: "Peter Schumann",
      role: "Operations manager",
      credentials: "",
      quote: "For nearly 25 years, Peter has been La Fontaine's very own jack of all trades. Chances are you'll find him wherever he's needed - behind the bar or taking care of the countless behind-the-scenes details. Peter keeps the house running.",
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/peter-bf3i7479-web.jpg"
    }
  ];

  const currentSlide = slides[activeSlide];

  return (
    <div className="bg-black text-neutral-300 min-h-screen font-sans selection:bg-white selection:text-black">
      <Metadata title={metadata.family.title} description={metadata.family.description} />

      {/* Hero Banner (with Balderdash-inspired layout) */}
      <div className="relative min-h-[90vh] sm:h-screen flex flex-col justify-center items-center bg-black overflow-hidden border-b border-neutral-900">
        <div className="relative w-full aspect-[4/3] sm:absolute sm:inset-0 sm:h-full sm:w-full sm:aspect-auto overflow-hidden border-b border-white/10 sm:border-b-0">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/image_1.png"
            alt="La Fable Jazz Club Background"
            className="w-full h-full object-cover object-center opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
        </div>
        
        <div className="text-center z-10 space-y-6 w-full max-w-3xl px-6 py-12 sm:py-0">
          <span className="font-sans text-xs tracking-[0.3em] uppercase text-neutral-400 block font-medium">
            La Fontaine's Curious Cousin
          </span>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-widest leading-none text-white select-none uppercase">
            The Family
          </h1>
          <div className="h-[1px] w-12 bg-white/20 my-6 mx-auto" />
          <p className="font-sans text-xs sm:text-sm md:text-base font-normal text-neutral-200 leading-relaxed max-w-2xl mx-auto">
            La Fable is the newest member of the La Fontaine family. We'd like to think of it as La Fontaine's curious cousin.
          </p>
        </div>
      </div>

      {/* Split-Grid Section 1: The People */}
      <section className="w-full bg-wine-950 border-b border-neutral-900">
        {/* Full Width Container (Text Content with Interactive Carousel) */}
        <div className="max-w-5xl mx-auto flex flex-col justify-center p-12 sm:p-16 lg:p-24 space-y-8">
          <div className="space-y-2">
            <span className="font-sans text-xs tracking-[0.2em] uppercase text-neutral-400 block font-medium">
              The People
            </span>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-black text-white tracking-tighter uppercase leading-tight">
              Meet the family
            </h2>
            <div className="w-12 h-[1px] bg-neutral-800" />
          </div>

          {/* Interactive Carousel */}
          <div className="relative min-h-[220px] flex flex-col justify-between space-y-6">
            {/* Slide Content */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-8 transition-all duration-500 ease-in-out">
              {/* Slide Image */}
              <div className="w-32 sm:w-48 md:w-56 h-auto border border-neutral-800 rounded-none overflow-hidden flex-shrink-0 bg-neutral-900">
                <img
                  src={currentSlide.image}
                  alt={currentSlide.name}
                  className="w-full h-auto object-contain"
                />
              </div>

              {/* Slide Text */}
              <div className="space-y-2 flex-1">
                <h4 className="font-display text-lg text-white font-bold uppercase tracking-wider">
                  {currentSlide.name}
                </h4>
                {currentSlide.role && (
                  <p className="font-sans text-[10px] text-sand-200 uppercase tracking-widest font-semibold">
                    {currentSlide.role} {currentSlide.credentials && <span className="text-neutral-400">({currentSlide.credentials})</span>}
                  </p>
                )}
                <p className="font-sans text-xs sm:text-sm text-neutral-400 leading-relaxed font-normal pt-1">
                  {currentSlide.quote}
                </p>
              </div>
            </div>

            {/* Carousel Controls */}
            <div className="flex items-center justify-between pt-4 border-t border-neutral-900">
              {/* Slide Numbers */}
              <div className="font-sans text-xs tracking-widest text-neutral-500 font-medium">
                <span className="text-white">0{activeSlide + 1}</span> / 0{slides.length}
              </div>

              {/* Navigation Buttons */}
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setActiveSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1))}
                  className="w-10 h-10 border border-neutral-800 hover:border-white hover:bg-white/5 text-neutral-400 hover:text-white transition-all duration-300 flex items-center justify-center rounded-none cursor-pointer"
                  aria-label="Previous slide"
                >
                  <i className="fa-light fa-arrow-left text-sm" />
                </button>
                <button
                  onClick={() => setActiveSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1))}
                  className="w-10 h-10 border border-neutral-800 hover:border-white hover:bg-white/5 text-neutral-400 hover:text-white transition-all duration-300 flex items-center justify-center rounded-none cursor-pointer"
                  aria-label="Next slide"
                >
                  <i className="fa-light fa-arrow-right text-sm" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Split-Grid Section 2: Our Roots */}
      <section className="grid grid-cols-1 md:grid-cols-2 w-full border-b border-neutral-900">
        {/* Left Column (Text Content) */}
        <div className="bg-[#f8f3eb] flex flex-col justify-center p-12 sm:p-16 lg:p-24 space-y-6">
          <span className="font-sans text-xs tracking-[0.2em] uppercase text-neutral-500 block font-medium">
            Our Roots
          </span>
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-black text-neutral-900 tracking-tighter uppercase leading-tight">
            More than 65 years of history
          </h2>
          <div className="w-12 h-[1px] bg-neutral-300" />
          
          <div className="space-y-6 font-sans text-xs sm:text-sm text-neutral-700 leading-relaxed">
            <p className="font-medium text-neutral-900 text-sm sm:text-base">
              For more than 65 years, La Fontaine has been a place where people have gathered over live jazz and late-night conversations. La Fable grows from the same roots - with wine at the centre of the table.
            </p>
            <p>
              Thoughtfully chosen wines, classic cocktails with a personal touch, and, of course, generous hosts.
            </p>
          </div>

          <div className="pt-4">
            <a
              href="https://www.lafontaine.dk/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 border border-neutral-900 text-neutral-900 text-[10px] uppercase tracking-[0.2em] hover:bg-neutral-900 hover:text-white transition-all duration-300 inline-flex items-center justify-center gap-2 group font-medium rounded-none"
            >
              Visit La Fontaine Jazz Club
              <i className="fa-solid fa-arrow-up-right-from-square text-[9px] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>

        {/* Right Column (Visual Graphic) */}
        <div className="relative min-h-[350px] md:min-h-full bg-neutral-950 overflow-hidden">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/image_3.png"
            alt="La Fontaine Jazz Piano"
            className="absolute inset-0 w-full h-full object-cover opacity-60 hover:opacity-80 transition-opacity duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-transparent to-transparent md:hidden" />
        </div>
      </section>
    </div>
  );
}
